export default __webpack_public_path__ + "static/media/extreme_radius_base.450ad1c1.svg";